import api from './api';

export type SubscriptionTier = 'free' | 'pro' | 'enterprise';
export type BillingPlan = 'monthly' | 'annual';

export interface BillingStatus {
  tier: SubscriptionTier;
  status: string | null; // trialing | active | past_due | canceled | ...
  periodEnd: string | null; // ISO date
  hasStripeCustomer: boolean;
  /** True for self-registered users who haven't yet completed the Stripe onboarding. */
  requiresOnboarding: boolean;
}

/** Current subscription snapshot for the logged-in user. */
export async function getBillingStatus(): Promise<BillingStatus> {
  const { data } = await api.get<BillingStatus>('/billing/status');
  return data;
}

/** Starts a Stripe Checkout session; returns the URL to redirect to. */
export async function startCheckout(plan: BillingPlan): Promise<string> {
  const { data } = await api.post<{ url: string }>('/billing/checkout', { plan });
  return data.url;
}

/** Opens the Stripe Customer Portal; returns the URL to redirect to. */
export async function openPortal(): Promise<string> {
  const { data } = await api.post<{ url: string }>('/billing/portal', {});
  return data.url;
}
